module.exports = __webpack_public_path__ + "static/en-2-f28cac9818ba1e947c4b15d1b36ad48f.png";